import localeData from "common/locales";
import { ReactNode } from "react";
import { IntlProvider } from "react-intl";
import { useAppStore } from "stores/useAppStore";

export default function AppLocaleProvider({
  children,
}: {
  children: ReactNode;
}) {
  const locale = useAppStore((state) => state.locale);
  // Changing language must not remount the router, forms, or notifications.
  return (
    <IntlProvider
      locale={locale}
      messages={localeData[locale] ?? localeData.en}
    >
      {children}
    </IntlProvider>
  );
}
